module.exports = __webpack_public_path__ + "img/background-crew-mobile.630a1d66.jpg";